module.exports = __webpack_public_path__ + "static/media/usb-mini-gold.3efaae40.svg";